import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ConnectedSystem,
  ConnectedSystemAuth,
  ConnectedSystemSliceState,
} from "./connectedSystem-interface";
import {
  fetchConnectedSystemAuths,
  fetchConnectedSystems,
  fetchConnectedSystemsByApplication,
  fetchConnectedSystemsById,
} from "./connectedSystem-async-calls";

const initialState: ConnectedSystemSliceState = {
  connectedSystems: [],
  connectedSystemAuths: [],
  selectedConnectedSystem: null,
  selectedConnectedSystemInitial: null,
  selectedConnectedSystemAuth: null,
  isFetching: false,
};

const connectedSystemsSlice = createSlice({
  name: "connectedSystems",
  initialState,
  reducers: {
    setSelectedConnectedSystem: (
      state,
      action: PayloadAction<ConnectedSystem>
    ) => {
      state.selectedConnectedSystem = action.payload;
    },
    setSelectedConnectedSystemAuth: (
      state,
      action: PayloadAction<ConnectedSystemAuth>
    ) => {
      state.selectedConnectedSystemAuth = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchConnectedSystemsByApplication.pending, (state) => {
        state.connectedSystems = [];
        state.isFetching = true;
      })
      .addCase(
        fetchConnectedSystemsByApplication.fulfilled,
        (state, action) => {
          state.connectedSystems = action.payload;
          state.isFetching = false;
        }
      )
      .addCase(fetchConnectedSystemsByApplication.rejected, (state) => {
        state.connectedSystems = [];
        state.isFetching = false;
      })
      .addCase(fetchConnectedSystems.pending, (state) => {
        state.connectedSystems = [];
        state.isFetching = true;
      })
      .addCase(fetchConnectedSystems.fulfilled, (state, action) => {
        state.connectedSystems = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchConnectedSystems.rejected, (state) => {
        state.connectedSystems = [];
        state.isFetching = false;
      })
      .addCase(fetchConnectedSystemsById.pending, (state) => {
        state.selectedConnectedSystem = null;
        state.selectedConnectedSystemInitial = null;
        state.selectedConnectedSystemAuth = null;
        state.isFetching = true;
      })
      .addCase(fetchConnectedSystemsById.fulfilled, (state, action) => {
        state.selectedConnectedSystem = action.payload;
        state.selectedConnectedSystemInitial = action.payload;
        if (action.payload.auth)
          state.selectedConnectedSystemAuth = action.payload.auth;
        state.isFetching = false;
      })
      .addCase(fetchConnectedSystemsById.rejected, (state) => {
        state.selectedConnectedSystem = null;
        state.selectedConnectedSystemInitial = null;
        state.selectedConnectedSystemAuth = null;
        state.isFetching = false;
      })
      .addCase(fetchConnectedSystemAuths.pending, (state) => {
        state.connectedSystemAuths = [];
        state.isFetching = true;
      })
      .addCase(fetchConnectedSystemAuths.fulfilled, (state, action) => {
        state.connectedSystemAuths = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchConnectedSystemAuths.rejected, (state) => {
        state.connectedSystemAuths = [];
        state.isFetching = false;
      });
  },
});

export const { setSelectedConnectedSystem, setSelectedConnectedSystemAuth } =
  connectedSystemsSlice.actions;

export default connectedSystemsSlice.reducer;
